import React, { Component } from 'react'
import { CustomInput, Label, Input, FormGroup, FormFeedback, Form } from 'reactstrap';
import EirButton from '../eir-button/EirButton';
import EirRecaptcha from '../eir-recaptcha/EirRecaptcha';

export class EirOnlineUnlockingCodeForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sending: false,
            countyList: [],
            response: null,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillMount = () => {
        fetch('/json/counties.txt')
            .then(res => res.json())
            .then(data => this.setState({ countyList: data }))
    }
    renderContent = (content) => {

        return { __html: content };

    }
    emailScript = (e) => {
        var email_val = $("#Customers_Email_Address").val();
        $("#EMAIL_FROM_ADDRESS_OVERRIDE").val(email_val);
    }
    async handleSubmit(event) {
        let form = event.target;
        event.preventDefault();
        event.stopPropagation();
        form = $("form")[0];
        if (form.checkValidity() != false) {
            this.setState({
                sending: true
            });

            let response = await fetch(this.props.action,
                {
                    method: form.method,
                    body: new FormData($("form")[0])
                }
            );

            this.setState({
                response: (response.ok ? await response.json() : false),
                sending: false
            });
            if ((this.state.response != null && this.state.response.result.status == 'success') || (this.state.response != null && (this.state.response.result.status == 'failure' || this.state.response == false))) {
                let scrollStep = -window.pageYOffset / (1000 / 15);
                let scrollInterval = setInterval(function () {
                    if (window.pageYOffset != 0) {
                        window.scrollBy(0, scrollStep);

                    } else clearInterval(scrollInterval);
                }, 15);
            }
        }
        form.classList.add('was-validated');

        if ($(".was-validated .form-control:invalid")[0] != undefined) {
            $(".was-validated .form-control:invalid")[0].focus();
        }
    }
    render() {

        const CList = this.state.countyList.counties;

        return (
            <div className="bereavement-forms">
                <div className="mb-5 mt-5 container d-flex flex-column align-items-center justify-content-center">
                    <h2>Mobile Handset Unlocking Code requests Form</h2>
                    <p>Filling out the below form will allow us to process your request to unlock your mobile handset in a timely manner without needing to contact.</p>
                    <p>Requests for unlocking codes can be created after the mobile handset has been active on an account for 7 months.</p>
                    <p>We will endeavour to return an unlocking code within 10 days to the email provided, however in some circumstances we may need to send this request to the manufacturer to have this code issued. Should this occur we will send you an update advising of this using one of the below contacts listed on the form.</p>
                    <p>For further information click here to see our <a aria-label="Frequently asked questions" target="_blank" href="https://eir.ie/support/mobile/unlocking-code/">Frequently asked questions.</a> </p>
                   

                </div>
                {(this.state.response == null && !this.state.sending) && (

                    <Form method="post" action={this.props.action} noValidate={false} className="needs-validation d-flex flex-column align-items-center justify-content-center" id="bereavement-form" onSubmit={this.handleSubmit} >
                        <Input type="hidden" value={this.props.email} id="Email_To_Address" name="Email_To_Address" />
                        <Input type="hidden" value="Mobile Handset Unlocking Code requests Form" id="Email_Subject" name="Email_Subject" />
                        <Input type="hidden" value={this.props.formName} id="Form_Name" name="Form_Name" />
                        <Input type="hidden"  id="EMAIL_FROM_ADDRESS_OVERRIDE" name="EMAIL_FROM_ADDRESS_OVERRIDE" />


                        {/* Customer Identity */}
                        <Input type="hidden" value="Customer Details:" id="Customer_Sub_Heading" name="Customer_Sub_Heading" />
                        <div className="customer-identity-container">
                            <h4>
                                Customer Details:
                            </h4>
                            <FormGroup>
                                <Label>Customer's First Name<span className="mandatory">*</span></Label>
                                <Input name="Customers_First_Name" pattern="[a-zA-Z'’\s]+" type="text" id="Customers_First_Name" required />
                                <FormFeedback>Please enter first name</FormFeedback>
                            </FormGroup>
                            <FormGroup>
                                <Label>Customer's Surname<span className="mandatory">*</span></Label>
                                <Input name="Customers_Surname" pattern="[a-zA-Z'’\s]+" type="text" id="Customers_Surname" required />
                                <FormFeedback>Please enter a name</FormFeedback>
                            </FormGroup>
                            <FormGroup>
                                <Label>Account Number<span className="mandatory">*</span></Label>
                                <Input type="text" name="Customers_Account_Number" id="Customers_Account_Number" required />
                                <FormFeedback>Please enter a valid account number</FormFeedback>
                            </FormGroup>
                            <FormGroup>
                                <Label>Mobile Number</Label>
                                <Input type="tel" minLength="6" maxLength="10" pattern="^[0-9-+s()]*$" name="Customers_Mobile_No" id="Customers_Mobile_No" />
                            </FormGroup>
                            <FormGroup>
                                <Label>Email address<span className="mandatory">*</span></Label>
                                <Input type="email" name="Customers_Email_Address" id="Customers_Email_Address" onChange={this.emailScript} required />
                                <p>This is required to contact you with the unlocking code for your mobile handset.</p>
                                <FormFeedback>Please enter a valid email address</FormFeedback>
                            </FormGroup>

                            <FormGroup>
                                <Label>Customer's address line 1<span className="mandatory">*</span></Label>
                                <Input name="Customers_Address_One" type="text" id="Customers_Address_One" required />
                                <FormFeedback>Please enter address line 1 </FormFeedback>
                            </FormGroup>
                            <FormGroup>
                                <Label>Customer's address line 2</Label>
                                <Input name="Customers_Address_Two" type="text" id="Customers_Address_Two" />
                            </FormGroup>
                            <FormGroup>
                                <Label>Town/City<span className="mandatory">*</span></Label>
                                <Input name="Customers_Town_City" type="text" id="Customers_Town_City" required />
                                <FormFeedback>Please enter Town/City</FormFeedback>
                            </FormGroup>
                            <FormGroup>
                                <Label>County<span className="mandatory">*</span></Label>
                                <Input type="select" name="Customers_County" id="Customers_County" required>
                                    <option value="">Select County</option>
                                    {CList != undefined &&
                                        (CList.map((name, i) => <option key={name.name}>{name.name}</option>))
                                    }
                                </Input>
                                <FormFeedback>Please enter county </FormFeedback>
                            </FormGroup>
                            <FormGroup>
                                <Label>Eircode<span className="mandatory">*</span></Label>
                                <Input name="Customers_Eircode" type="text" id="Customers_Eircode" minLength="7" maxLength="8" pattern="^[0-9a-zA-Z\s]*$" required />
                                <FormFeedback>Please enter Eircode </FormFeedback>
                            </FormGroup>

                            {/* Refund Details */}

                            <div>
                                <h4>
                                Mobile Handset details:
                            </h4>
                                <Input type="hidden" value="Mobile Handset details:" id="Close_Sub_Heading" name="Close_Sub_Heading" />
                                <FormGroup>
                                <Label>Make of handset<span className="mandatory">*</span></Label>
                                <Input name="Make_Of_Handset" type="text" id="Make_Of_Handset" required />
                                <FormFeedback>Please enter Make of handset</FormFeedback>
                            </FormGroup>
                            <FormGroup>
                                <Label>Model of handset<span className="mandatory">*</span></Label>
                                <Input name="Model_Of_Handset" type="text" id="Model_Of_Handset" required />
                                <p>The model of a handset can be located underneath the battery or on the phone's original packaging.</p>
                                <FormFeedback>Please enter Model of handset</FormFeedback>
                            </FormGroup>
                                <FormGroup>
                                    <Label>Mobile number currently used in the handset <span className="mandatory">*</span></Label>
                                    <Input name="Mobile_Number_Used_In_Handset" pattern="^[0-9-+s()]*$" type="text" id="Mobile_Number_Used_In_Handset" required />
                                    <FormFeedback>Please enter Mobile number currently used in the handset</FormFeedback>
                                </FormGroup>
                                <FormGroup>
                                <Label>IMEI<span className="mandatory">*</span></Label>
                                <Input type="tel" minLength="15" maxLength="15" pattern="^[0-9-+s()]*$" name="IMEI" id="IMEI" required/>
                                <p>It is essential to include all 15 digits of the IMEI. The IMEI of a handset can be obtained by dialling *#06# into the handset while powered on. The IMEI will then pop up on the handset's screen and will contain 15 digits in total.</p>
                                <FormFeedback>Please enter IMEI</FormFeedback>
                                </FormGroup>
                                </div>

                            <div>
                                {/* Confirmation Details */}

                                <FormGroup >
                                    <div >
                                        <div className="form-group">
                                            <div>
                                                <div className="custom-checkbox custom-control">
                                                    <Input required name="Request_To_Manufaturer_Accepted" type="checkbox" id="Request_To_Manufaturer_Accepted" className="custom-control-input" value="true" />
                                                    <label className="custom-control-label" htmlFor="Request_To_Manufaturer_Accepted">I understand that in some circumstances some requests may need to go to the manufacturer to retrieve this <br/>code and can extend the timeline to over 15 working days dependent on the manufacturer.</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </FormGroup>
                               
                                {/* Form Confirmation */}
                                <p className="justify-content">The personal data logged on this form will be processed in accordance with eir’s privacy policy. The use of which is to process the request to provide an unlocking code. The data will not be used for any other purpose. By clicking submit you confirm that you have read and understood this policy.</p>
                            </div>

                        </div>




                        <div className="d-flex justify-content-start">
                            <EirRecaptcha />
                        </div>

                        <div className="mt-4 d-flex justify-content-center">
                            <button type="submit"  aria-label="Submit form" name="Submit" value="Submit" className="btn btn-primary" 
                                onClick={this.handleSubmit}>Submit</button>

                        </div>
                    </Form>
                )
                }

                {(this.state.response != null && this.state.response.result.status == 'success') && (
                    <div className="form-success align-items-center" dangerouslySetInnerHTML={this.renderContent(this.props.successMsg)}></div>
                    )}

                {(this.state.response != null && (this.state.response.result.status == 'failure' || this.state.response == false)) && (
                    <div className="form-error align-items-center">Form Submitted Failed</div>
                )}
            </div>
        )
    }
}

export default EirOnlineUnlockingCodeForm;


